import Vue from 'vue'
import Vuex from 'vuex'
import api from '../services/api'
import localforage from 'localforage'
import { app } from './modules/app.module'
import { dashboard } from './modules/dashboard.module'
import { filters } from './modules/filters.module'
import { auth } from './modules/auth.module'
import { notifications } from './modules/notifications.module'
import { promotions } from './modules/promotions.module'
import { promotion } from './modules/promotion.module'
import { subscriptions } from './modules/subscriptions.module'
import { merchants } from './modules/merchants.module'
import { favorites } from './modules/favorites.module'
import { promoTypes } from './modules/promoTypes.module'
import { companies } from './modules/companies.module'
import { labels } from './modules/labels.module'
import { labelGroups } from './modules/labelGroups.module'
import { header } from './modules/header.module'
import { modal } from './modules/modal.module'
import { preview } from './modules/preview.module'
import { services } from './modules/services.module'
import { settlements } from './modules/settlements.module'
import { reports } from './modules/reports.module'
import { promoRealizations } from './modules/reports/promoRealizations.module'
import { promoUsage } from './modules/reports/promoUsage.module'
import { lotteryUsage } from './modules/reports/lotteryUsage.module'
import { diagnostics } from './modules/reports/diagnostics.module'
import { promoBillings } from './modules/reports/promoBillings.module'
import { saleGoals } from './modules/reports/saleGoals.module'
import { mKasa } from './modules/reports/mKasa.module'
import { invalidUsageProducts } from './modules/reports/invalidUsageProducts.module'
import { myShop } from './modules/reports/myShop.module'
import { targetReport } from './modules/reports/targetReport.module'
// temporary disabled
// import { promoPlan } from './modules/reports/promoPlan.module'
import { products } from './modules/products.module'
import { devices } from './modules/devices.module'
import { saleTrend } from './modules/statistics/saleTrend.module'
import { cashAmount } from './modules/statistics/cashAmount.module'
import { topTen } from './modules/statistics/topTen.module'
import { news } from './modules/news.module'
import { announcements } from './modules/announcements/announcements.module'
import { newsletters } from './modules/announcements/newsletters.module'
import { snippets } from './modules/snippets.module'
import { user } from './modules/user.module'
import { recipients } from './modules/recipients.module'
import { mailRecipients } from './modules/mailRecipients.module'
import { consents } from './modules/settings/consents.module'
import { stores } from './modules/settings/stores.module'
import { documents } from './modules/settings/documents.module'
import { walkthrough } from './modules/walkthrough.module'
import { userDataProcessing } from './modules/userDataProcessing.module'
import { emails } from './modules/emails.module'
import { faqs } from './modules/settings/faqs.module'
import { generateLink } from './modules/generateLink.module'
import { lottery } from './modules/lottery.module'
import { confirmationWindow } from './modules/confirmationWindow.module'
import { advertisements } from './modules/advertisements.module'
import { localForagePagination } from './modules/localForagePagination.module'
import { promoGroups } from './modules/promoGroups.module'
import { storeUsers } from './modules/settings/storeUsers.module'
import { addNewPromo } from './modules/addNewPromo.module'
import { exportFiles } from './modules/exportFiles.module'
import { tutorials } from './modules/settings/tutorials.module'
import { promotionsLimits } from './modules/promos/promotionsLimits.module'
import { altEans } from './modules/altEans.module'
import { myBusiness } from './modules/my-business/my-business.module'
import { newspaperMaterials } from './modules/my-business/newspaperMaterials.module'

Vue.use(Vuex)

const store = new Vuex.Store({
    modules: {
        app,
        auth,
        notifications,
        promotions,
        promotion,
        promoGroups,
        subscriptions,
        labels,
        labelGroups,
        favorites,
        filters,
        dashboard,
        modal,
        preview,
        promoTypes,
        merchants,
        header,
        companies,
        services,
        settlements,
        products,
        devices,
        saleTrend,
        cashAmount,
        topTen,
        news,
        announcements,
        newsletters,
        snippets,
        // temporary disabled
        // promoPlan,
        user,
        recipients,
        consents,
        stores,
        documents,
        walkthrough,
        userDataProcessing,
        emails,
        faqs,
        generateLink,
        lottery,
        confirmationWindow,
        advertisements,
        localForagePagination,
        storeUsers,
        addNewPromo,
        exportFiles,
        reports,
        promoRealizations,
        promoUsage,
        lotteryUsage,
        diagnostics,
        promoBillings,
        saleGoals,
        mKasa,
        invalidUsageProducts,
        myShop,
        targetReport,
        tutorials,
        promotionsLimits,
        altEans,
        mailRecipients,
        myBusiness,
        newspaperMaterials
    }
})

store.$api = api
store.$storage = localforage.createInstance({
    storeName: 'm-promo'
})

export default store
